import { Box } from "@mui/material";
import React from "react";
import type { Status } from "../../types";
import { STATUS_COLOR } from "../../constants";
import { alpha } from "@mui/material/styles";

type Size = "sm" | "md";

const sizeMap: Record<Size, number> = {
  sm: 10,
  md: 14,
};

export type TrafficLightProps = {
  status: Status;
  size?: Size;
};

export const TrafficLight = ({ status, size = "sm" }: TrafficLightProps) => {
  const px = sizeMap[size];
  const c = STATUS_COLOR[status].main;

  return (
    <Box
      sx={{
        width: px,
        height: px,
        borderRadius: "50%",
        backgroundColor: c,
        boxShadow: `0 0 0 3px ${alpha(c, 0.15)}`,
      }}
    />
  );
};
